import errorManager from '@/rollbar.js';

const confirmModal = (target) => {
  let url = target.dataset.url;
  const message = target.dataset.message;

  const consent = confirm(message);
  if (!consent) {
    const urlObj = new URL(url, document.baseURI);
    urlObj.searchParams.set('no_copy', 'true');
    url = urlObj.toString();
  }

  window.location.replace(url);
};

const setListener = (selector) => {
  const elements = document.querySelectorAll(selector);
  elements.forEach((element) => {
    element.removeEventListener('click', element._clickListener);
    element._clickListener = (e) => {
      confirmModal(e.currentTarget);
    };
    element.addEventListener('click', element._clickListener);
  });
};

const init = (selector) => {
  try {
    setListener(selector);
  } catch (e) {
    errorManager(e);
  }
};

window.GuestVmdCopy = {
  init: init,
};
